var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c("v-col", { attrs: { cols: _vm.leftColSize } }, [
            _c(
              "h1",
              { staticClass: "headline" },
              [
                _vm._t("default", function () {
                  return [_vm._v(_vm._s(_vm.text))]
                }),
                _vm.resultsCount !== null
                  ? [
                      _c("span", { staticClass: "font-weight-light" }, [
                        _vm._v("(" + _vm._s(_vm.resultsCount) + ")"),
                      ]),
                    ]
                  : _vm._e(),
                _c("v-spacer"),
              ],
              2
            ),
          ]),
          _c(
            "v-col",
            { attrs: { cols: _vm.rightColSize } },
            [
              _c(
                "v-row",
                {
                  staticClass: "text-right",
                  attrs: { align: "center", justify: "end", "no-gutters": "" },
                },
                [
                  _vm._t("toolbar.prepend"),
                  _vm.mode === "grid" && !!_vm.addButtonRoute
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mx-1",
                          attrs: {
                            color: "primary",
                            icon: "",
                            to: _vm.addButtonRoute,
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-plus")])],
                        1
                      )
                    : _vm._e(),
                  _vm.mode === "entity"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mr-1",
                          attrs: { text: "", icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.back()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-window-close")])],
                        1
                      )
                    : _vm._e(),
                  _vm._t("toolbar.append"),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-0" },
            [
              _c("v-progress-linear", {
                style: { visibility: !_vm.loading ? "hidden" : "visible" },
                attrs: { indeterminate: _vm.loading, color: "primary" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }